<script setup>
import ModuleMiniPlayer from '@/components/modules/ModuleMiniPlayer.vue'
import { onMounted, ref, computed, onUnmounted } from 'vue'
import { useBreakpoint } from '@/composables/useBreakpoints'
import NavigationLayout from '@/components/layout/NavigationLayout.vue'
import NavigationBroadcast from '@/components/layout/NavigationBroadcast.vue'
import ArticleHeaderLayout from '@/components/layout/ArticleHeaderLayout.vue'
import { useSectionsStore } from '@/stores/section'
import { useBroadcastStore } from '@/stores/broadcast'
import { storeToRefs } from 'pinia'

const sectionsStore = useSectionsStore()
const { pageSettings } = storeToRefs(sectionsStore)

const broadcast = useBroadcastStore()
const { programItems } = storeToRefs(broadcast)
const broadcastItems = computed(() => programItems.value.length)

// sticky header
const broadcastContent = ref(null)
const isSticky = ref(false)
const scrollTop = ref(0)
const isArticleScrolled = ref(false)
const showArticleTitle = ref(false)
const previousScrollPosition = ref(0)
const currentScrollPosition = ref(0)
const isScrolledBroadcast = ref(false)
const showMiniPlayer = ref(true)

const articleHeader = computed(() => pageSettings.value.type === 'NEWS')
const { isTablet } = useBreakpoint()

const onScroll = (e) => {
  if (e) {
    scrollTop.value = e.target?.documentElement?.scrollTop
    const broadcast = document.getElementById('broadcast')?.getBoundingClientRect()
    const screeningWrap = document.getElementById('screening__wrap')?.getBoundingClientRect()
    if(broadcast) {
      if(broadcast.bottom <= 0) {
        isSticky.value = true
        isScrolledBroadcast.value = true
        document.body.style.overflowX = 'unset'
      } else {
        isSticky.value = false
        isScrolledBroadcast.value = false
      }
    }

    let nav = document.querySelector('.nav')
    let navOffset = nav.getBoundingClientRect().top
    let screening = document.querySelector('.screening')
    if (navOffset > 0 && screening) {
      screening.style.backgroundPosition = `center ${navOffset}px`
    }

    if (articleHeader.value) {
      currentScrollPosition.value = scrollTop.value
      if (currentScrollPosition.value < previousScrollPosition.value && articleHeader.value) {
        isSticky.value = false
        isArticleScrolled.value = true
        showArticleTitle.value = false
      } else {
        if(screeningWrap) {
          if((screeningWrap.y + 50) < 0) {
            showArticleTitle.value = true
          }
        }
      }
      previousScrollPosition.value = currentScrollPosition.value
    }
  }
}

const isLargeScreen = ref(false)
const pageType = computed(() => pageSettings.value.type)

const checkConditions = () => {
  isLargeScreen.value = window.innerWidth > 1024

  if (pageType.value === 'SG') {
    showMiniPlayer.value = isLargeScreen.value
  } else if (pageType.value === 'NEWS' && !isLargeScreen.value) {
    showMiniPlayer.value = false
  } else {
    showMiniPlayer.value = true
  }
}

onMounted(() => {
  checkConditions()
  window.addEventListener('resize', checkConditions)
  previousScrollPosition.value = scrollTop.value
  window.addEventListener('scroll', onScroll)
})
onUnmounted(() => {
  window.removeEventListener('resize', checkConditions)
  window.removeEventListener('scroll', onScroll)
})
</script>
<template>
  <header
    class="nav"
    :class="{
      'page-scrolled': isSticky,
      'article-scrolled': isArticleScrolled,
      'scrolled-broadcast': isScrolledBroadcast,
      'empty-broadcast': !broadcastItems
    }"
  >
    <navigation-broadcast ref="broadcastContent" />
    <article-header-layout v-if="articleHeader && showArticleTitle && isTablet" />
    <navigation-layout v-else />

    <module-mini-player v-if="showMiniPlayer"/>

  </header>
</template>
<style lang="scss">
@import '@/assets/scss/components/layout/header-layout.scss';
.apology-time {
  margin: 10px auto;
}
.apology-time .container {
  padding:10px;
  border:1px solid #000;
  text-align: center;
}
.apology-time .container a {
  background-color: #ba2324;
    color: #fff;
    display: block;
    padding: 5px;
    font-size: 16px;
    width: 135px;
    margin: 0 auto;
}
</style>
